<svg [style.height]="height || '1rem'" [style.width]="width || '1rem'" class="animate-animateSpinnerRotate relative" viewBox="25 25 50 50">
  <circle class="animate-animateSpinnerDash" [style.stroke]="color" cx="50" cy="50" r="20" fill="none"
    stroke-miterlimit="10" stroke-width="7" stroke-linecap="round"></circle>
</svg>